<template>
  <v-app>
    <div
      class="vs-bg"
      fill-height
    >
      <v-container
        fluid
        fill-height
      >
        <app-content />
        <connection-checker />
        <service-worker />
      </v-container>
    </div>
  </v-app>
</template>

<script>
import AppContent from '@/components/layout/AppContent'
import ConnectionChecker from '@/components/ConnectionChecker'
import ServiceWorker from '@/components/ServiceWorker'

export default {
  name: 'CanvasLayout',
  components: {
    AppContent,
    ConnectionChecker,
    ServiceWorker
  }
}
</script>

<style lang="scss" scoped>
.vs-bg {
  background: url(/static/images/vs-bg.jpg) no-repeat;
  background-size: cover;
  height: 100vh;
}
</style>
